import React, { useState } from 'react';
import './manage-question-sets.styles.scss'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faEllipsisV, faPen, faPlus } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import Modal from '../modal/modal.component';
import { useSelector } from 'react-redux';

const ManageQuestionSets = ({
  questionSets,
  archiveQuestionSet,
}) => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const [selectedQuestionSet, setSelectedQuestionSet] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={`form-builder_manage-question-sets ${screenSize}`}>
      <div style={{ 'height': '1rem' }}></div>

      <div className='form-builder_question-set-landing'>
        <div className='form-builder_head-row'>
          <h3>Manage Question Sets</h3>
          <div className='form-builder_buttons'>
            <Link to={-1}>
              <button className='form-builder_button small-btn'>
                Cancel
              </button>
            </Link>
            <Link to={`${location.pathname}/create`}>
              <button className='form-builder_button small-btn'>
                Create New Question Set
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </Link>
          </div>
        </div>
        <div className="form-builder_question-set-table-container">
          <table className='form-builder_table'>
            <thead>
              <tr>
                <th></th>
                <th>Question Set Name</th>
                <th className="center-align">Date Created</th>
                <th className="center-align" title="Question Count">Q Count</th>
                {/* <th className="center-align" title="Required For All">RFA</th>
                <th className="center-align" title="Coach/Protege Comparison Questions">Comparison</th> */}
                <th className="center-align">Status</th>

              </tr>
            </thead>
            <tbody>
              {
                Object.values(questionSets).length > 0
                  ?
                  Object.values(questionSets)
                    .filter(set => set.status !== 'archived')
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((set, index) => (
                      <tr key={set.id}>
                        <td>
                          <button
                            className='form-builder_button small-btn'
                            onClick={() => setSelectedQuestionSet(set)}>
                            <FontAwesomeIcon icon={faEllipsisV} />
                          </button>
                        </td>
                        <td>{set.name}</td>
                        <td className="center-align">{format(new Date(set.ts_created), 'P')}</td>
                        <td className='center-align'>{Object.values(set.questions).length}</td>
                        {/* <td className='center-align'>
                          {
                            set.requiredForAll
                              ? '✔'
                              : ''
                          }
                        </td>
                        <td className='center-align'>
                          {
                            set.comparison
                              ? '✔'
                              : ''
                          }
                        </td> */}
                        <td className="center-align">{set.status}</td>

                      </tr>
                    ))
                  :
                  <tr>
                    <td colSpan="7">No Question Sets Available</td>
                  </tr>

              }
            </tbody>
          </table>
        </div>
      </div>

      <div className="question-set-menu-modal">
        <Modal
          show={!!selectedQuestionSet}
          cancel={() => setSelectedQuestionSet(null)}
          closeButton={true}
          cls="narrow"
          text="Question Set Menu"
        >
          <div className="question-set-menu-options">
            <button
              className="form-builder_button med-btn"
              onClick={() => {
                navigate(`${location.pathname}/edit/${selectedQuestionSet.id}`);
                setSelectedQuestionSet(null);
              }}>
              <FontAwesomeIcon icon={faPen} />
              Edit Question Set
            </button>
            <button
              className="form-builder_button med-btn"
              onClick={() => {
                archiveQuestionSet();
                setSelectedQuestionSet(null);
              }}>
              <FontAwesomeIcon icon={faArchive} />
              Archive Question Set
            </button>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default ManageQuestionSets